import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../dto/api-response.response';
import { OriginPointResponse } from '../dto/origin-point.response';
import { OriginPointRequest } from '../dto/origin-point.request';

@Injectable({ providedIn: 'root' })
export class OriginPointService {
    private readonly baseUrl = `${environment.apiUrl}/origin-points`;

    constructor(private http: HttpClient) { }

    getAll(filters?: { id?: number; status?: number }): Observable<ApiResponse<OriginPointResponse[]>> {
        let params = new HttpParams();
        if (filters?.id != null) params = params.set('id', filters.id);
        if (filters?.status != null) params = params.set('status', filters.status);
        return this.http.get<ApiResponse<OriginPointResponse[]>>(this.baseUrl, { params });
    }

    create(request: OriginPointRequest): Observable<ApiResponse<OriginPointResponse>> {
        return this.http.post<ApiResponse<OriginPointResponse>>(this.baseUrl, request);
    }

    update(id: number, request: OriginPointRequest): Observable<ApiResponse<OriginPointResponse>> {
        return this.http.put<ApiResponse<OriginPointResponse>>(`${this.baseUrl}/${id}`, request);
    }

    updateStatus(id: number, status: number): Observable<ApiResponse<void>> {
        return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/status`, { status });
    }

    setDefault(id: number): Observable<ApiResponse<void>> {
        return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/default`, {});
    }
}
